import React from 'react';
import PropTypes from 'prop-types';
import './csmArticleContent.css';
import {
  nl2p,
  imageBaseUrl,
  dataBaseUrl,
  imageResizeBaseUrl,
  imageCropBaseUrl,
  getProp,
  transformTvKosiceVideoToStandardArticle,
} from './../../utilities.js';
import { StandardArticle } from './../../component/article/';
import { Icon } from './../../component/icon';
import { Comments } from './../../component/facebook';
import { Photogallery } from './../../component/photogallery';
import Election from '../election/election';
import { Loader } from '../loader';
import InstagramEmbed from 'react-instagram-embed';
import { TwitterTweetEmbed } from 'react-twitter-embed';

class CsmArticleContent extends React.Component {
  componentDidMount() {
    if (!this.refresh()) {
      setTimeout(() => {
        this.refresh();
      }, 1000);
    }
  }

  componentDidUpdate() {
    this.refresh();
  }

  refresh() {
    if (typeof window.FB !== 'undefined') {
      getProp(window.FB, 'XFBML.parse', () => {})();
      return true;
    }
    return false;
  }

  renderWidget(widget) {
    if (getProp(widget, 'isHidden', false)) {
      return null;
    }

    if (widget.type === 'text') {
      return (
        <div>
          {widget.header ? <h2>{widget.header}</h2> : null}
          <div dangerouslySetInnerHTML={{ __html: widget.text }} />
        </div>
      );
    } else if (widget.type === 'unformattedText') {
      return (
        <div>
          {widget.header ? <h2>{widget.header}</h2> : null}
          <p dangerouslySetInnerHTML={{ __html: nl2p(widget.text) }} />
        </div>
      );
    } else if (widget.type === 'photo') {
      let source = getProp(widget, 'source');
      let imbaseurl;
      if (widget.crop && widget.dimensions) {
        imbaseurl = imageCropBaseUrl(
          widget.dimensions.X,
          widget.dimensions.Y,
          widget.dimensions.W,
          widget.dimensions.H,
          1000,
          0,
        );
      } else {
        imbaseurl = imageResizeBaseUrl(1000);
      }
      return (
        <div className="text-center photo-widget">
          <span className="thumbnail">
            <img src={`${imbaseurl}/${widget.uri}`} alt={'Foto'} />
          </span>
          {widget.description && (
            <div className="description">
              <em>
                {widget.description}
                {source && <span>&nbsp;/&nbsp;{source}</span>}
              </em>
            </div>
          )}
        </div>
      );
    } else if (widget.type === 'youtube') {
      if (widget.embedurl) {
        return (
          <div className="text-center youtube-widget">
            <div className="thumbnail">
              <iframe
                title="youtube-video"
                width="100%"
                height="100%"
                src={`${widget.embedurl}`}
                frameBorder="0"
                allowFullScreen
              />
            </div>
          </div>
        );
      } else {
        return null;
      }
    } else if (widget.type === 'table') {
      const table = widget.table
        .map((row, rowIdx) => {
          const rowContent = row
            .map((col, colIdx) => {
              if (widget.header.includes('t') && rowIdx === 0) {
                return `<th>${col}</th>`;
              } else if (
                widget.header.includes('b') &&
                rowIdx === widget.table.length - 1
              ) {
                return `<th>${col}</th>`;
              } else if (widget.header.includes('l') && colIdx === 0) {
                return `<th>${col}</th>`;
              } else if (
                widget.header.includes('r') &&
                colIdx === widget.table[0].length - 1
              ) {
                return `<th>${col}</th>`;
              } else {
                return `<td>${col}</td>`;
              }
            })
            .join('');
          return `<tr>${rowContent}</tr>`;
        })
        .join('');
      return (
        <div className="table-widget">
          {widget.title ? <h2>{widget.title}</h2> : null}
          <div className="table-responsive">
            <table
              className="table table-hover"
              dangerouslySetInnerHTML={{ __html: table }}
            />
          </div>
        </div>
      );
    } else if (widget.type === 'photogallery') {
      return (
        <div className="photogallery-widget">
          <h2>Galéria k článku</h2>
          <Photogallery photos={getProp(widget, 'pictures', [])} />
        </div>
      );
    } else if (widget.type === 'imagead') {
      if (widget.uri) {
        let img = (
          <img
            src={`${imageResizeBaseUrl(1000)}/${widget.uri}`}
            alt={getProp(widget, 'description')}
          />
        );
        return (
          <div className="imagead-widget text-center">
            {widget.target ? (
              <a href={widget.target} target="_blank">
                {img}
              </a>
            ) : (
              img
            )}
          </div>
        );
      } else {
        return null;
      }
    } else if (widget.type === 'tvkosice') {
      if (widget.reportage) {
        const article = transformTvKosiceVideoToStandardArticle(
          widget.reportage,
        );
        return (
          <div className="text-center tvkosice-widget">
            <div className="thumbnail text-left">
              <StandardArticle
                size="lg"
                articleHeadContent={
                  getProp(widget.reportage, 'original.path') && (
                    <div className="tvkosice-video-duration">
                      <Icon name="play-circle" />
                      {getProp(
                        widget.reportage,
                        'original.duration',
                        '',
                      ).substr(3)}
                    </div>
                  )
                }
                article={article}
                articleTitleSubtitle={'Televízia Košice'}
                baseUrl="https://www.tvkosice.sk"
                articleTitleExtra={getProp(article, 'section.name')}
                imgOverride={
                  imageBaseUrl(600) + '/' + getProp(article, 'picture.uri')
                }
              />
            </div>
          </div>
        );
      } else {
        return null;
      }
    } else if (widget.type === 'audio') {
      if (widget.uri) {
        return (
          <div className="audio-widget">
            <p>
              {widget.name && (
                <span>
                  <strong>{widget.name}</strong>
                </span>
              )}
              {widget.description && (
                <span>
                  {widget.name && ' - '}
                  <em>{widget.description}</em>
                </span>
              )}
            </p>
            <audio controls src={`${dataBaseUrl()}/${widget.uri}`} />
          </div>
        );
      } else {
        return null;
      }
    } else if (widget.type === 'fbVideo') {
      return (
        <div className="facebook-video-widget">
          <div className="thumbnail">
            <div
              className="fb-video"
              data-href={widget.uri}
              data-width="600"
              data-allowfullscreen="true"
              data-autoplay="false"
              data-show-text="true"
            />
          </div>
        </div>
      );
    } else if (widget.type === 'video') {
      return (
        <div className="own-video-widget">
          <div className="thumbnail">
            <video className="video-container" controls="controls">
              <source
                src={`https://data.tvkosice.sk/cmdata/${widget.uri}`}
                type="video/mp4"
              />
            </video>
          </div>
          <div className="description">
            <em>
              {widget.description}
              {widget.source && <span>&nbsp;/&nbsp;{widget.source}</span>}
            </em>
          </div>
        </div>
      );
    } else if (widget.type === 'instagramPost') {
      return (
        <InstagramEmbed
          url={widget.uri}
          maxWidth={600}
          hideCaption={false}
          containerTagName="div"
          protocol=""
          injectScript
          onLoading={() => <Loader loading />}
          onSuccess={() => {}}
          onAfterRender={() => {}}
          onFailure={() => <span>Nepodarilo sa načítať príspevok</span>}
          className="instagram-post-widget"
        />
      );
    } else if (widget.type === 'twitterPost') {
      const regexResult = getProp(widget, 'uri', '').match(
        /((https:\/\/)?(www\.)?)?twitter\.com\/([a-zA-Z0-9_-]+)\/status\/([0-9]+)/,
      );
      const tweetId =
        regexResult && regexResult.length
          ? regexResult[regexResult.length - 1]
          : '';
      return (
        <div className="twitter-post-widget">
          <TwitterTweetEmbed tweetId={tweetId} />
        </div>
      );
    } else if (widget.type === 'soundcloud') {
      return (
        <div className="soundcloud-wrapper">
          <iframe
            id={widget.uuid}
            title={widget.uuid}
            width="100%"
            height="166"
            scrolling="no"
            frameborder="no"
            src={`https://w.soundcloud.com/player/?url=${getProp(
              widget,
              'uri',
              '',
            )}?auto_play=false&hide_related=true`}
          />
        </div>
      );
    }
  }

  renderElectionWidget(url) {
    switch (url) {
      case 'volby2020': {
        return <Election />;
      }
      case 'volby2020/definitivne-vysledky': {
        return <Election hideUpdateTime={true} />;
      }
      case 'volby2020/slovensko': {
        return <Election widgetType="slovakia" />;
      }
      case 'volby2020/kraj': {
        return <Election widgetType="region" />;
      }
      case 'volby2020/kosice': {
        return <Election widgetType="kosice" />;
      }
      case 'volby2020/okres': {
        return <Election widgetType="district" />;
      }
      default:
        return null;
    }
  }

  render() {
    const facebookLink =
      process.env.REACT_APP_CONTENT_SPACE === 'kosiceonline'
        ? 'kosiceonline'
        : 'RadioKosice';
    try {
      const style = {};
      if (!this.props.bottomGutter) {
        style['marginBottom'] = 0;
      }
      const isPerexHidden = getProp(this.props.content, 'perexHidden', false);
      return (
        <div className="article-content" style={style}>
          {this.props.content.perex && !isPerexHidden ? (
            <p className="perex">
              <strong>{this.props.content.perex}</strong>
            </p>
          ) : null}
          {getProp(this.props.content, 'widgets', []).map((item, idx) => {
            return <div key={idx}>{this.renderWidget(item)}</div>;
          })}
          {this.renderElectionWidget(getProp(this.props.content, 'url', ''))}
          {this.props.allowComments && (
            <React.Fragment>
              <div className="facebook-page-button-wrapper">
                <button className="facebook-page-button">
                  <a
                    href={`https://www.facebook.com/${facebookLink}`}
                    target="_blank"
                  >
                    Sledujte najnovšie články na našom Facebooku
                  </a>
                </button>
              </div>
              <div>
                <h2 className="h2">Komentáre</h2>
                <Comments canonicalUrl={this.props.canonicalUrl} />
              </div>
            </React.Fragment>
          )}
        </div>
      );
    } catch (e) {
      console.error(e);
    }
  }
}

CsmArticleContent.defaultProps = {
  allowComments: false,
  bottomGutter: true,
};

CsmArticleContent.propTypes = {
  content: PropTypes.object.isRequired,
  allowComments: PropTypes.bool,
  canonicalUrl: PropTypes.string,
  bottomGutter: PropTypes.bool,
};

export default CsmArticleContent;



// WEBPACK FOOTER //
// ./src/ui/src/component/csmArticle/csmArticleContent.js